<template>
    <div class="charge-info" id="charge-info">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1">&nbsp;</div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <input type="text" class="search-inp" style="padding-left:5px;" v-model="searchPhone" placeholder="请输入会员手机号码.（选填）" />
                        <div class="date-filter" v-if="nowType=='MONTH'">
                            <el-date-picker v-model="dateStr" type="month" ref='dateInput' value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="请选择选择日期">
                            </el-date-picker>
                            <i class="iconfont icon-jiantou" @click="$refs.dateInput.handleFocus()"></i>
                        </div>
                        <div class="time-range-filter" v-if="nowType=='TIME_RANGE'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            placeholder="结束时间">
                            </el-date-picker>
                            <span class="quick-filter">
                                <span :class="nowSelFilter=='today'?'active':''" @click.stop="filter('today')">今日</span>
                                <span :class="nowSelFilter=='lastDay'?'active':''" @click.stop="filter('lastDay')">昨日</span>
                                <span :class="nowSelFilter=='week'?'active':''" @click.stop="filter('week')">本周</span>
                                <span :class="nowSelFilter=='lastWeek'?'active':''" @click.stop="filter('lastWeek')">上周</span>
                                <span :class="nowSelFilter=='month'?'active':''" @click.stop="filter('month')">本月</span>
                                <span :class="nowSelFilter=='lastMonth'?'active':''" @click.stop="filter('lastMonth')">上月</span>
                            </span>
                            <span class="types typesSearch" >
                                <span type="button" @click="searchConfirm">查询</span>
                            </span>
                        </div>
                        
                        <!--  -->
                        <!-- <div class="type-change" @click="nowType=='MONTH'?nowType='TIME_RANGE':nowType='MONTH'">
                            <span>{{nowType=='MONTH'?'按时间段查询':'按月查询'}}</span>
                        </div> -->
                        <button v-if="nowType=='MONTH'" class="do-search" @click="doSearch">查询</button>
                        <span class="total-charge">总充值金额：{{totalChargeAmount.toFixed(2)}}</span>
                        <span class="total-charge">总赠送金额：{{totalDiscountAmount.toFixed(2)}}</span>
                    </div>
                </div>
          
                <div class="HSpace2">&nbsp;</div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:10%">序号</th>
                                <th style="width:15%">时间</th>
                                <th style="width:15%">会员名</th>
                                <th style="width:10%">会员号码</th>
                                <th style="width:10%">充值金额</th>
                                <th style="width:15%">赠送金额</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:verifiList.length>pageSize}">
                                    <tr v-for="(item,ind) in verifiList" class="listTr">
                                        <td style="width:10%">{{item.paymentTime?ind+1+(currentPage-1)*pageSize:""}}</td>
                                        <td style="width:15%">{{item.paymentTime | dateForGradePage}}</td>
                                        <td style="width:15%">{{item.memberName}}</td>
                                        <td style="width:10%">{{item.mobile}}</td>
                                        <td style="width:10%">{{item.amount}}</td>
                                        <td style="width:15%">{{item.discount}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                    </el-pagination>
                </div>
                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props: ['curStoreId','pageSize'],
        data () {
            return {
                nowSelFilter:"month",
                totalDiscountAmount:0,//总的赠送金额
                totalChargeAmount:0,//总的充值金额
                verifiList: [], // 核销详情
                nowType:"TIME_RANGE",
                startTime:'',//按时间段查询的起始时间
                endTime:'',//按时间段查询的结束时间
                pickerOptions: {
                    disabledDate(time) {
                    return time.getTime() > Date.now();
                    }
                },
                dateStr: new Date().Format("yyyy-MM"),
                currentPage: 1,
                totalElements: 0, //数据总条数
                canClick:true,
                searchPhone:"",//会员搜索手机号
            }
        },
        watch: {
            dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM"));
            let nowDate = new Date(val).Format("yyyy-MM");
            this.dateStr = nowDate;
            // this.getChargeInfo(0, nowDate);
            }
        },
        methods: {
            filter(type){
                let timeRangeArr = [];
                this.nowSelFilter = type;
                switch (type) {
                    case "today":
                        // this.yearMonth = new Date().Format("yyyy-MM");
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        // let year = new Date().Format("yyyy");
                        // let month = new Date().Format("MM");
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastDay":
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        this.startTime = `${new Date(new Date(this.startTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 00:00:00`;
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.endTime = `${new Date(new Date(this.endTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "week":
                        timeRangeArr = this.$dateRange.getThisWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastWeek":
                        timeRangeArr = this.$dateRange.getLastWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "month":
                        timeRangeArr = this.$dateRange.getThisMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastMonth":
                        timeRangeArr = this.$dateRange.getLastMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    default:
                        break;
                }
            },
            doSearch(){
                let timeStr = new Date(this.dateStr).getTime() + "-" + new Date(this.dateStr).getTime();
                let nowTime = new Date().getTime();
                if(!(this.$canClickSelect("chargeInfoMonth",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                if(this.canClick){
                    this.canClick = false;
                    this.getChargeInfo(0,this.dateStr);
                }
            },
            //分页方法
            handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            console.log(this.dateStr);
            if(this.nowType == "MONTH"){
                this.getChargeInfo(val - 1, this.dateStr,"MONTH");
            }else{
                this.getChargeInfo(val - 1, this.dateStr,"ARB");
            }
            },
            // 搜索
            searchConfirm: function () {
                // 
                let timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
                let nowTime = new Date().getTime();
                if(!(this.$canClickSelect("chargeInfoTimeRange",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                // 



                if(((new Date(this.endTime)).getTime() - (new Date(this.startTime)).getTime()) > 1000*60*60*24*35){
                        this.$message({
                            message: '只能查询35天内的数据',
                            customClass: 'error'
                        })
                        return;
                }
                if(this.startTime!=='' && this.endTime!==''){
                    if(new Date(this.startTime)>new Date(this.endTime)){
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(this.canClick){
                        this.canClick = false;
                        this.getChargeInfo(0, this.dateStr,"ARB");
                    }
                }else{
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    })
                    return;
                }
            },
            // 获取核销详情
            getChargeInfo: function (page, date, type="MONTH") {
                let params;
                if(this.searchPhone){
                    if(!/^(\d){11}$/.test(this.searchPhone)){
                        this.$message({
                            message: '手机号输入有误',
                            customClass: 'error'
                        })
                        setTimeout(()=>{
                            this.canClick = true;
                        },500);
                        return;
                    }
                    if(type == "MONTH"){
                        params = {
                            storeId:this.curStoreId,
                            time:date,
                            type,
                            page,
                            size: this.pageSize,
                            mobile:this.searchPhone
                        }
                    }else{
                        let begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                        let end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                        params = {
                            storeId:this.curStoreId,
                            begin,
                            end,
                            type,
                            page,
                            size: this.pageSize,
                            mobile:this.searchPhone
                        }
                    }
                }else{
                    if(type == "MONTH"){
                        params = {
                            storeId:this.curStoreId,
                            time:date,
                            type,
                            page,
                            size: this.pageSize,
                        }
                    }else{
                        let begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                        let end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                        params = {
                            storeId:this.curStoreId,
                            begin,
                            end,
                            type,
                            page,
                            size: this.pageSize,
                        }
                    }
                }
                
                
                this.$http({
                    url:"get-charge",
                    method:"GET",
                    params
                }).then(res=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                    let body = res.data;
                    if(body.result.code == 200){
                        this.verifiList = body.data;
                        let number = this.pageSize - this.verifiList.length;
                        this.totalElements = body.totalElements;
                        this.totalChargeAmount = body.amount;
                        this.totalDiscountAmount = body.discount;
                        if ( number > 0 ) {
                            for (let i = 0; i < number; i++) {
                                this.verifiList.push({
                                    id: '', // 员工id
                                    name: '', // 员工姓名
                                    code: '', // 编号
                                    mobile: '', // 手机
                                    groupName: '' // 岗位id
                                });
                            }
                        }
                    }else{
                        this.$message({
                            message: body.result.msg,
                            customClass: 'error'
                        });
                    }
                }).catch((err) => {
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                });
            },
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.verifiList.push({
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    groupName: '' // 岗位id
                })
            }
            // 获取员工列表
            this.startTime = `${new Date().Format("yyyy/MM")}-01 00:00:00`;
            let year = new Date().Format("yyyy");
            let month = new Date().Format("MM");
            this.endTime =  `${new Date(year,month,0).Format("yyyy/MM/dd")} 23:59:59`;
        },
        mounted: function () {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "./chargeInfo.scss";
</style>



// WEBPACK FOOTER //
// chargeInfo.vue?03bf376b